import Tabs, { TabPane } from 'rc-tabs';
import TabBar from 'rc-tabs/lib/TabBar';
import InkTabBar from 'rc-tabs/lib/InkTabBar';
import ScrollableTabBar from 'rc-tabs/lib/ScrollableTabBar';
import ScrollableInkTabBar from 'rc-tabs/lib/ScrollableInkTabBar';
import SwipeableInkTabBar from 'rc-tabs/lib/SwipeableInkTabBar';
import TabContent from 'rc-tabs/lib/TabContent';
import SwipeableTabContent from 'rc-tabs/lib/SwipeableTabContent';
import './index.less';

const WeaPortalRcTabs = {
  Tabs,
  TabPane,
  TabBar,
  InkTabBar,
  ScrollableTabBar,
  ScrollableInkTabBar,
  SwipeableInkTabBar,
  TabContent,
  SwipeableTabContent,
};

export default WeaPortalRcTabs;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/components/wea-portal-rc-tabs/index.js